import com.github.chosamuel.kishibe.math.Vector2
import kotlinx.browser.window

fun createSquareGrid(
    dim: Int,
    size: Double,
): List<List<Vector2>> {
    val xpad = (window.innerWidth - size) * 0.5
    val ypad = (window.innerHeight - size) * 0.5
    val spacing = size / (dim - 1).toDouble()
    val vertices = mutableListOf<MutableList<Vector2>>()
    repeat(dim){ y ->
        vertices.add(mutableListOf<Vector2>())
        repeat(dim){ x ->
            vertices[y].add(
                Vector2(x*spacing+xpad,y*spacing+ypad)
            )
        }
    }
    return vertices
}


